import snrCheckImg from "../../assets/snr_check.svg";
import vadCheckImg from "../../assets/vad_check.svg";

const QUALITY_FAIL_IMAGES = {
  qualityNoise: snrCheckImg,
  qualitySilence: vadCheckImg,
  qualityNoSpeech: vadCheckImg,
};

export function getQualityFailImage(qualityIssueKey) {
  return QUALITY_FAIL_IMAGES[qualityIssueKey] ?? vadCheckImg;
}
